import { defineMessages } from 'react-intl';

export const przelewyPaypoMessages = defineMessages({
  paymentErrorMessage: {
    id: 'checkout.cartPage.oalt.error.closeAndRepeate',
    defaultMessage: 'Error message for repeate or close payment',
  },
});
